// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"8de582a5","455":"22f3e151","977":"8a6acbf9"}[chunkId] + ".chunk.js";
};